import React from 'react';

import config from 'configs/app';
import { useMultichainContext } from 'lib/contexts/multichain';

import useProvider from './useProvider';
import { getHexadecimalChainId } from './utils';

function getParams(chainConfig: typeof config): { chainId: string } {
  if (!chainConfig.chain.id) {
    throw new Error('Missing required chain config');
  }

  return { chainId: getHexadecimalChainId(Number(chainConfig.chain.id)) };
}

export default function useSwitchChain() {
  const { data: { wallet, provider } = {} } = useProvider();
  const multichainContext = useMultichainContext();

  const chainConfig = multichainContext?.chain.app_config ?? config;

  return React.useCallback(async() => {
    if (!wallet || !provider) {
      throw new Error('Wallet or provider not found');
    }

    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [ getParams(chainConfig) ],
      });
    } catch (error) {
      // Error 4902 means the chain hasn't been added yet
      if ((error as any).code === 4902) {
        throw new Error('Network not added to wallet');
      }
      throw error;
    }
  }, [ wallet, provider, chainConfig ]);
}
